import { useState } from 'react'
import { QueryClient, QueryClientProvider } from 'react-query';
import { ToastContainer } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
import './App.css';
import { WaitlistRouter } from './pages/waitlist/router';
import { LoginRouter } from './pages/web/login/login';
// import WebHome from '/./pages/web/home';


const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      staleTime: 1000 * 60 * 10, // Data is considered fresh for 10 minutes
      cacheTime: 1000 * 60 * 15, // Data is kept in cache for 15 minutes
      refetchOnMount: false, // Do not refetch on component mount
      refetchOnWindowFocus: false, // Do not refetch on window focus
    },
  },
});

const App = () => {
  const [isWaitlist, ] = useState(false);
  return (
    <QueryClientProvider client={queryClient}>
      <div className="App">
        {isWaitlist ? <WaitlistRouter /> : <LoginRouter />}
        <ToastContainer />
      </div>
      </QueryClientProvider>
  )
}

export default App

export function getParam(name){
  if(name===(new RegExp('[?&]'+encodeURIComponent(name)+'=([^&]*)')).exec(window.location.search))
     return decodeURIComponent(name[1]);
}